module.exports = __webpack_public_path__ + "static/media/login_bottom_back.3a2972b5.svg";